
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Cheapurbaniarentalinpune() {



    const cardData =
    {
        keyword: 'Cheap Urbania rental in Pune ',
        heading: 'Amruta Travels: Cheap Urbania rental in Pune ',
        headingDescription: 'Amruta Travels offers cheap Urbania rental in Pune, providing an affordable yet comfortable group travel solution without compromising on quality. Ideal for family trips, corporate travel, airport transfers, school outings, and weekend getaways, our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities. With experienced drivers, transparent pricing, punctual service, and 24/7 support, Amruta Travels ensures budget-friendly Urbania rentals in Pune that are safe, reliable, and hassle-free.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Book Force Urbania per km Pune",
    "description": "Book Force Urbania per km in Pune with transparent pricing and no hidden charges. Enjoy luxury AC interiors, cushioned pushback seating, ample luggage space, and professional drivers, making it ideal for city travel, airport transfers, corporate trips, and short outstation journeys at a per km rate."
  },
  {
    "name": "Online Force Urbania per km booking Pune",
    "description": "Online Force Urbania per km booking in Pune for quick and hassle-free reservations. Well-maintained vehicles with air conditioning, comfortable seating, clean interiors, and experienced drivers ensure safe, reliable, and budget-friendly travel for local and outstation use."
  },
  {
    "name": "Force Urbania Rent Per Km in Pune & PCMC",
    "description": "Force Urbania rent per km in Pune & PCMC with flexible billing options. Suitable for family trips, corporate travel, airport transfers, and sightseeing, offering AC comfort, spacious seating, luggage capacity, and trained drivers at economical per km rates."
  },
  {
    "name": "17 Seater Force Urbania Per Km Rate Pune",
    "description": "17 seater Force Urbania per km rate in Pune for group travel and events. Spacious luxury interiors, full air-conditioning, comfortable seating, and professional drivers make it perfect for corporate outings, weddings, and family trips with cost-effective per km pricing."
  },
  {
    "name": "Luxury Force Urbania Rental Per Km Pune",
    "description": "Luxury Force Urbania rental per km in Pune for premium travel needs. Designed for comfort and style with AC interiors, plush seating, ample legroom, luggage space, and expert drivers, ideal for executives, VIP guests, and long-distance travel."
  },
  {
    "name": "Urbania Bus Rental Service in Pune",
    "description": "Urbania bus rental service in Pune for families, corporate groups, and tourists. Vehicles feature AC interiors, cushioned seating, clean cabins, luggage space, and professional drivers, ensuring smooth travel at affordable and transparent rates."
  },
  {
    "name": "Urbania Bus Rental Service in Pimpri Chinchwad",
    "description": "Urbania bus rental service in Pimpri Chinchwad with well-maintained vehicles, AC comfort, cushioned seating, and experienced drivers. Ideal for local trips, airport transfers, family outings, and outstation travel at budget-friendly prices."
  },
  {
    "name": "Cheap Urbania rental in Pune",
    "description": "Cheap Urbania rental in Pune offering comfortable AC vehicles at economical rates. Suitable for families, corporate travel, and group trips, with clean interiors, ample space, and professional drivers without compromising on safety or comfort."
  },
  {
    "name": "Low cost Urbania hire Pune",
    "description": "Low cost Urbania hire in Pune for budget-conscious travelers. Enjoy AC comfort, cushioned seating, luggage space, and reliable drivers, making it ideal for daily travel, airport transfers, and short outstation journeys."
  },
  {
    "name": "Budget Urbania on rent Pune",
    "description": "Budget Urbania on rent in Pune with affordable pricing and quality service. Vehicles are air-conditioned, spacious, and driven by trained professionals, perfect for family trips, weddings, and corporate travel."
  },
  {
    "name": "Affordable Urbania Bus rental Pune",
    "description": "Affordable Urbania bus rental in Pune combining comfort and value. AC interiors, cushioned seats, ample luggage space, and experienced drivers make it suitable for group travel, sightseeing, and long-distance journeys."
  },
  {
    "name": "Best price Urbania rental Pune",
    "description": "Best price Urbania rental in Pune with competitive rates and premium service. Enjoy comfortable AC seating, clean interiors, professional drivers, and flexible rental options for local and outstation travel."
  },
  {
    "name": "Urbania rental at lowest price Pune",
    "description": "Urbania rental at the lowest price in Pune without compromising on quality. Vehicles come with AC, cushioned seating, luggage space, and skilled drivers, ideal for families, corporate groups, and tourists."
  },
  {
    "name": "Urbania rent Pune cheapest rate",
    "description": "Urbania rent in Pune at the cheapest rate for economical travel. Well-maintained AC vehicles with spacious seating and professional drivers make group travel affordable and comfortable."
  },
  {
    "name": "Urbania hire Pune budget price",
    "description": "Urbania hire in Pune at budget-friendly prices for city travel, airport transfers, and outstation trips. AC interiors, cushioned seats, luggage space, and reliable drivers ensure value-for-money travel."
  },
  {
    "name": "Urbania rental Pune low fare",
    "description": "Urbania rental in Pune with low fare options for families and groups. Comfortable AC interiors, spacious seating, and experienced drivers provide safe and economical transportation."
  },
  {
    "name": "Urbania van hire Pune economical",
    "description": "Economical Urbania van hire in Pune for budget travel needs. AC comfort, cushioned seating, luggage capacity, and professional drivers make it ideal for local use and short outstation trips."
  },
  {
    "name": "Urbania on rent Pune low budget",
    "description": "Urbania on rent in Pune for low-budget travel with reliable service. Enjoy air-conditioned comfort, spacious interiors, and trained drivers for family trips, weddings, or corporate travel."
  },
  {
    "name": "Cost effective Urbania rental Pune",
    "description": "Cost-effective Urbania rental in Pune offering a balance of comfort and affordability. Vehicles include AC interiors, cushioned seating, ample space, and professional drivers for all travel needs."
  },
  {
    "name": "Cheap Urbania rental Baner Pune",
    "description": "Cheap Urbania rental in Baner Pune for local and outstation trips. AC vehicles with comfortable seating, clean interiors, and skilled drivers ensure economical yet comfortable travel."
  },
  {
    "name": "Budget Urbania hire Hinjewadi Pune",
    "description": "Budget Urbania hire in Hinjewadi Pune for IT companies, corporate travel, and family trips. AC comfort, spacious seating, luggage space, and professional drivers at affordable rates."
  },
  {
    "name": "Affordable Urbania rental Kharadi Pune",
    "description": "Affordable Urbania rental in Kharadi Pune with well-maintained AC vehicles, cushioned seating, luggage capacity, and trained drivers, suitable for corporate travel and airport transfers."
  },
  {
    "name": "Low cost Urbania hire Hadapsar Pune",
    "description": "Low cost Urbania hire in Hadapsar Pune for budget-friendly travel. Comfortable AC interiors, spacious seating, and reliable drivers make it ideal for family and group travel."
  },
  {
    "name": "Cheap Urbania van rental Wakad Pune",
    "description": "Cheap Urbania van rental in Wakad Pune offering economical rates with AC comfort, cushioned seating, luggage space, and professional drivers for city and outstation travel."
  },
  {
    "name": "Budget Urbania hire Kothrud Pune",
    "description": "Budget Urbania hire in Kothrud Pune for families, corporate groups, and tourists. Vehicles feature AC interiors, comfortable seating, and experienced drivers at affordable pricing."
  },
  {
    "name": "Cheap Urbania for outstation Pune",
    "description": "Cheap Urbania for outstation travel from Pune to destinations like Lonavala, Mahabaleshwar, or Shirdi. AC comfort, spacious seating, luggage space, and professional drivers ensure economical long-distance travel."
  },
  {
    "name": "Budget Urbania for family trip Pune",
    "description": "Budget Urbania for family trips from Pune with AC interiors, cushioned seating, and ample space. Ideal for safe, comfortable, and affordable family outings and tours."
  },
  {
    "name": "Affordable Urbania for wedding Pune",
    "description": "Affordable Urbania rental in Pune for wedding transport. AC comfort, spacious seating, clean interiors, and professional drivers make it perfect for guest and family transportation."
  },
  {
    "name": "Low cost Urbania for corporate travel Pune",
    "description": "Low cost Urbania for corporate travel in Pune offering reliable and professional service. AC interiors, comfortable seating, and trained drivers are ideal for meetings, conferences, and employee transport."
  },
  {
    "name": "Cheap Urbania airport transfer Pune",
    "description": "Cheap Urbania airport transfer in Pune with timely pickups and drops. AC interiors, luggage-friendly design, comfortable seating, and professional drivers ensure stress-free airport travel."
  },
  {
    "name": "Cheap Urbania Rental in Pune & PCMC",
    "description": "Cheap Urbania rental in Pune & PCMC for families, corporate groups, and tourists. Well-maintained AC vehicles, spacious seating, and experienced drivers provide economical and reliable travel."
  },
  {
    "name": "Low Cost Force Urbania Hire Pune",
    "description": "Low cost Force Urbania hire in Pune combining luxury and affordability. AC interiors, cushioned seating, ample space, and professional drivers make it suitable for all travel purposes."
  },
  {
    "name": "Affordable 13 & 17 Seater Urbania Pune",
    "description": "Affordable 13 & 17 seater Urbania rentals in Pune for group travel, corporate events, weddings, and family trips. Spacious AC interiors, comfortable seating, luggage space, and experienced drivers at budget-friendly rates."
  }
],
"tableData": [
  ["Book Force Urbania per km Pune", "Online Force Urbania per km booking Pune"],
  ["Force Urbania Rent Per Km in Pune & PCMC", "17 Seater Force Urbania Per Km Rate Pune"],
  ["Luxury Force Urbania Rental Per Km Pune", "Urbania Bus Rental Service in Pune"],
  ["Urbania Bus Rental Service in Pimpri Chinchwad", "Cheap Urbania rental in Pune"],
  ["Low cost Urbania hire Pune", "Budget Urbania on rent Pune"],
  ["Affordable Urbania Bus rental Pune", "Best price Urbania rental Pune"],
  ["Urbania rental at lowest price Pune", "Urbania rent Pune cheapest rate"],
  ["Urbania hire Pune budget price", "Urbania rental Pune low fare"],
  ["Urbania van hire Pune economical", "Urbania on rent Pune low budget"],
  ["Cost effective Urbania rental Pune", "Cheap Urbania rental Baner Pune"],
  ["Budget Urbania hire Hinjewadi Pune", "Affordable Urbania rental Kharadi Pune"],
  ["Low cost Urbania hire Hadapsar Pune", "Cheap Urbania van rental Wakad Pune"],
  ["Budget Urbania hire Kothrud Pune", "Cheap Urbania for outstation Pune"],
  ["Budget Urbania for family trip Pune", "Affordable Urbania for wedding Pune"],
  ["Low cost Urbania for corporate travel Pune", "Cheap Urbania airport transfer Pune"],
  ["Cheap Urbania Rental in Pune & PCMC", "Low Cost Force Urbania Hire Pune"],
  ["Affordable 13 & 17 Seater Urbania Pune", "Urbania Bus Rental Service in Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Affordable and Cheap Urbania Rental in Pune",
    "WhyChoosedescription": "Amruta Travels offers cheap Urbania rental in Pune without compromising on comfort or quality. Get a budget-friendly yet premium travel solution for group trips."
  },
  {
    "WhyChooseheading": "Best Choice for Budget-Friendly Group Travel",
    "WhyChoosedescription": "Whether it’s a family outing, corporate trip, or local tour, our affordable Urbania rentals provide spacious and comfortable travel at economical prices."
  },
  {
    "WhyChooseheading": "Comfortable Interiors at Low Cost",
    "WhyChoosedescription": "Even at affordable rates, our Urbania vehicles feature comfortable seating, air conditioning, ample legroom, large windows, and sufficient luggage space."
  },
  {
    "WhyChooseheading": "Professional Drivers Included",
    "WhyChoosedescription": "All cheap Urbania rentals include experienced and courteous drivers who ensure a safe, smooth, and punctual journey across Pune and nearby destinations."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Amruta Travels provides clear and honest pricing. Our cheap Urbania rental packages come with upfront costs, ensuring excellent value for money."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Reliable Vehicles",
    "WhyChoosedescription": "All Urbania vehicles are regularly serviced and sanitized, ensuring hygiene, safety, and reliability even at budget-friendly rental rates."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Options",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations along with customizable routes to match your travel plan, keeping your journey affordable and convenient."
  },
  {
    "WhyChooseheading": "Easy Booking with Cost-Saving Support",
    "WhyChoosedescription": "Booking a cheap Urbania rental in Pune is quick and simple with Amruta Travels. Our support team helps you choose the most cost-effective option for your trip."
  }
]

    }

const faqData = [
  {
    question: 'How can I book a cheap Urbania rental in Pune?',
    answer: 'Booking a cheap Urbania rental in Pune is easy with Amruta Travels. You can book online, call our support team, or visit our office to get the best affordable option.'
  },
  {
    question: 'Is cheap Urbania rental still comfortable?',
    answer: 'Yes, our budget-friendly Urbania rentals offer comfortable seating, air conditioning, spacious interiors, and modern amenities for a pleasant travel experience.'
  },
  {
    question: 'Does cheap Urbania rental include a driver?',
    answer: 'Yes, every Urbania rental includes a professional and experienced driver, even with our affordable pricing packages.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain safety, hygiene, and comfort.'
  },
  {
    question: 'Can I rent Urbania cheaply for outstation trips?',
    answer: 'Yes, we offer affordable Urbania rental options for both local and outstation trips. Pricing depends on distance and duration.'
  },
  {
    question: 'What affects the cost of cheap Urbania rental in Pune?',
    answer: 'The cost depends on factors like trip duration, distance, seating capacity, and travel type. Contact Amruta Travels for the best available deal.'
  },
  {
    question: 'Can I customize pickup and drop-off locations?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization to suit your budget and travel needs.'
  },
  {
    question: 'Why choose Amruta Travels for cheap Urbania rental in Pune?',
    answer: 'Amruta Travels offers affordable pricing, well-maintained Urbania vehicles, professional drivers, and transparent costs, ensuring value-for-money travel.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Nitin Pawar',
    role: 'Group Trip Organizer, Pune',
    text: 'We booked a cheap Urbania rental for a group outing. The vehicle was clean, comfortable, and the pricing was very reasonable. Great service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Pooja Kulkarni',
    role: 'Family Trip Planner, Pune',
    text: 'Looking for a budget option, we chose Amruta Travels for Urbania rental. The experience was excellent and affordable. Highly recommended!',
    rating: 5
  }
];




















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "LocalBusiness",
      "name": "Amruta Travels",
      "image": "https://bushireinpune.com/assets/images/cheap-urbania-rental-pune.jpg",
      "url": "https://bushireinpune.com/cheap-urbania-rental-pune",
      "telephone": "+91 7353109555",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Pune",
        "addressRegion": "Maharashtra",
        "addressCountry": "IN"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.7",
        "ratingCount": "6421"
      }
    },
    {
      "@type": "Service",
      "serviceType": "Cheap Urbania Rental Pune",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Amruta Travels"
      },
      "areaServed": {
        "@type": "City",
        "name": "Pune"
      },
      "description": "Affordable and cheap Force Urbania rental in Pune for family trips, corporate travel, airport transfers and outstation tours."
    },
    {
      "@type": "Product",
      "name": "Cheap Urbania Rental in Pune",
      "image": "https://bushireinpune.com/assets/images/cheap-urbania-rental-pune.jpg",
      "description": "Budget-friendly Urbania rental in Pune with AC, pushback seats and experienced drivers. Available in 13 and 17 seater options.",
      "brand": {
        "@type": "Brand",
        "name": "Amruta Travels"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.7",
        "ratingCount": "6421"
      },
      "offers": {
        "@type": "Offer",
        "priceCurrency": "INR",
        "price": "22",
        "availability": "https://schema.org/InStock",
        "url": "https://bushireinpune.com/cheap-urbania-rental-pune"
      }
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is the cheapest Urbania rental price in Pune?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Cheap Urbania rental in Pune starts from ₹22 per km depending on trip type and seating capacity."
          }
        },
        {
          "@type": "Question",
          "name": "Is Urbania available for budget group travel?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Urbania is perfect for budget-friendly group travel including family trips, corporate tours and weddings."
          }
        },
        {
          "@type": "Question",
          "name": "Which Urbania seating options are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Urbania vans are available in 13 seater and 17 seater configurations for group travel."
          }
        }
      ]
    }
  ]
};



    return (
        <div>
<Helmet>
  <title>
    Cheap Urbania Rental in Pune | ₹22/km Budget Force Urbania Hire | Call 7353109555
  </title>

  <meta
    name="description"
    content="Book cheap Urbania rental in Pune at ₹22/km. Affordable 13 & 17 seater Force Urbania vans for family trips, corporate travel, airport transfer & Pune to Mumbai, Goa, Shirdi tours."
  />

  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/107.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cheapurbaniarentalinpune;